<template>
    <div>
        <v-card dark class="pa-4 grey darken-3 ma-4">
            <v-toolbar dark flat dense class="grey darken-3">
                <v-toolbar-title>Пакетний продаж Сертифікатів</v-toolbar-title>
            </v-toolbar>
           
            <v-card-text>
                <v-flex xs4 lg1>
                    <v-text-field v-model="f.id" label="ID користувача" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="f.fio" label="ПІБ користувача" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="f.phone" label="Телефон користувача" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-select v-model="project_id" :loading="loading" :items="projectsList" item-text="name" item-value="id" @change="calculateData"
                        cache-items flat 
                        label="Проєкт"></v-select>
                    <v-text-field v-model="f.contractorName" label="Контрагент користувача" readonly></v-text-field>

                </v-flex>
                <v-subheader>Продати Сертифікати</v-subheader>
                <v-flex xs12 lg6>
                    <v-simple-table dark>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Сертифікат
                                    </th>
                                    <th class="text-left">
                                        Замовлено
                                    </th>
                                    <th class="text-left">
                                        Доступно
                                    </th>
                                    <th class="text-left">
                                        Статус
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in orderedList" :key="item.name">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.ordered }}</td>
                                    <td>{{ item.avail }}</td>
                                    <td>
                                        <!-- ЯКЩО (Доступно < Замовлено), ТО іконка червоний хрестикІНАКШЕ іконка зелена галочка -->
                                        <v-icon v-if="item.avail < item.ordered" color="red">mdi-close</v-icon>
                                        <v-icon v-else color="green">mdi-check</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-alert type="error" v-if="unorderedList.length > 0" class="my-10">УВАГА! В замовлення проекту {{ projectName }} присутні невідомі сертифікати з кодами Тайфун: {{unorderedList}}» </v-alert>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="grey" @click="goBack()">
                    <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                </v-btn>
                <v-btn text v-if="canBuy"
                color="Egifts" @click="sendForm()">
                    Продати коди
                </v-btn>
            </v-card-actions>

        </v-card>
        <v-dialog v-model="successB" max-width="500">
            <v-card>
                <v-system-bar>
                    <v-spacer></v-spacer>
                    <v-icon @click="successB = false">mdi-close</v-icon>
                </v-system-bar>
                <v-card-text>
                    <h5>Успішно виконано замовлення проєкту {{ projectName }}</h5>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="Egifts" @click="successB = false">
                        Закрити
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog scrollable v-model="usersTable" max-width="1600">
            <v-card>
                <v-system-bar>
                    <v-spacer></v-spacer>
                    <v-icon @click="usersTable = false">mdi-close</v-icon>
                </v-system-bar>
                <v-toolbar flat dense class="">
                    <v-toolbar-title>Обрати користувача</v-toolbar-title>
                    <v-card-title class="headline"></v-card-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line
                        hide-details></v-text-field>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :headers="headers" :items="list" :footer-props="footerProps" :search="search"
                        class="ma-4" @click:row="fillCard">
                        <template v-slot:item.contractors="{ item }">
                            <span v-html="item.contractors"></span>
                        </template>
                        <template v-slot:item.shops="{ item }">
                            <span v-html="item.shops"></span>
                        </template>
                        <template v-slot:item.owner="{ item }">
                            <span v-if="item.owner == 1">Власник</span>
                        </template>
                        <template v-slot:no-data>
                            ...
                        </template>
                    </v-data-table>

                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions,
    mapGetters
} from 'vuex'

import {
    mask
} from "vue-the-mask"

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            ...mapGetters(['userInfo']),
            loading: false,
            items: [],
            search: null,
            select: null,
            f: {
                id: null,
                fio: null,
                phone: null,
                project_id: null,
                contractorName: null,
                contractorId: null,
            },
            project_id: null,
            usersTable: false,
            search: '',
            shops: [],
            successB: false,
            userData: {},
            orderedList: [],
            unorderedList: [],
            footerProps: {
                'items-per-page-options': [10, 20],
                'items-per-page-text': 'на стор.'
            },
            headers: [{
                text: 'ID',
                align: 'left',
                sortable: true,
                value: 'member_id',
                selected: false,
                width: '5%',
            },
            {
                text: 'Телефон',
                align: 'left',
                sortable: true,
                value: 'phone',
                selected: true,
                width: '10%',
            },
            {
                text: 'ПІБ',
                align: 'left',
                sortable: true,
                value: 'name',
                selected: true,
                width: '20%',
            },
            {
                text: 'E-mail',
                align: 'left',
                sortable: true,
                value: 'email',
                selected: true,
                width: '15%',
            },
            {
                text: 'Тип',
                align: 'left',
                sortable: true,
                value: 'owner',
                selected: true,
                width: '10%',
            },
            {
                text: 'Контрагенти',
                align: 'left',
                sortable: true,
                value: 'contractors',
                selected: true,
                width: '20%',
            },
            {
                text: 'ТТ',
                align: 'left',
                sortable: true,
                value: 'shops',
                selected: true,
                width: '20%',
            },
            ]
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'getUserInfo', 'touch', 'getEgiftsUnorderedGoods', 'getEgiftsProjectsList', 'getUsersList', 'getEgiftsAvailList', 'getMemberData', 'buyEgiftsPackageCodes', 'contractorsAutocomplete']),
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
        },
        getUsers() {
            this.usersTable = true
            this.getDataFromApi()
        },
        getDataFromApi() {
            this.getUsersList()
        },
        fillCard() {
            this.usersTable = false
            this.getMemberData(this.userInfo().id)
                .then(data => {
                    this.userData = data.userData || {}

                    this.f = {
                        id: this.userData.id,
                        fio: this.userData.surname + ' ' + this.userData.firstname + ' ' + this.userData.lastname,
                        phone: this.userData.phone,
                    }
                })
        },
        async sendForm() {
            this.loading = true
            this.buyEgiftsPackageCodes(this.f)
                .then(data => {
                    if (data.error) {
                        this.setSnackbar(['error', data.error])
                        this.getEgiftsAvailList(this.availList)
                    } else {
                        this.successB = true
                        this.getEgiftsAvailList({ project_id: this.project_id })
                    }
                })
                .catch(async error => {
                    this.setSnackbar(['error', error.response?.data?.error?.message || error.message])
                    console.log(error)
                }).finally(async () => {
                    this.orderedList = await this.getEgiftsAvailList({ project_id: this.project_id })
                    this.unorderedList = await this.getEgiftsUnorderedGoods({ project_id: this.project_id })

                    this.loading = false
                })
        },
        querySelections(q) {
            this.loading = true
            if (q.length < 3) {
                this.loading = false
                return
            }
            this.contractorsAutocomplete({ q })
                .then(data => {
                    this.items = data
                    this.loading = false
                })
                .catch(error => {
                    this.loading = false
                    console.log(error)
                })
        },
        async calculateData(id) {
            if (id) {
                this.orderedList = await this.getEgiftsAvailList({ project_id: id })
                this.unorderedList = await this.getEgiftsUnorderedGoods({ project_id: id })
                const selectedProject = this.projectsList.find(el => el.id === id)
                this.$set(this.f, 'contractorName', selectedProject.contractor_name)
                this.$set(this.f, 'contractorId', selectedProject.contractor_typhoon_id)
                this.$set(this.f, 'project_id', id)
            } else {
                this.$set(this.f, 'contractorName', )
                this.$set(this.f, 'contractorId', )

            }
        }
    },
    created() {
        this.getUserInfo(this)
        this.getEgiftsProjectsList()
        this.fillCard()
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.usersList
        },
        availList() {
            return this.$store.state.adminpanel.egiftsAvailList || []
        },
        wasSelectedPacks() {
            return this.availList.find(el => el.cnt && el.cnt > 0 && el.cnt > el.avail)
        },
        projectsList() {
            return this.$store.state.adminpanel.projectsList
        },
        projectName() {
            const project = this.projectsList.find(el => el.id === this.project_id)
            return project ? project.name : ''
        },
        canBuy() {
            return this.project_id && this.availList.find(el => el.ordered > 0) && !this.availList.find(el => el.ordered > el.avail) && this.unorderedList.length === 0
        },
    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },
    },
}
</script>

<style>
.inp-cnt {
    color: black;
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid rgb(7, 0, 0);
    width: 40px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}
</style>
